import { IJobParams } from "../../../../api/types/jobs/IJobParams";
import { RootState } from "../../../rootState";

export const withJobParentId = (params: IJobParams, state: RootState): IJobParams => {
  if (params.parent_id !== undefined) return params;
  const parentId = state.ticketGrids.parentId;
  if (parentId === undefined) return params;
  return { ...params, parent_id: parentId };
};
